module.exports = __webpack_public_path__ + "img/Header.c0c04603.jpg";